<template>
  <div class="Search" style="background: #f3f3f3">
    <headbox></headbox>
    <div class="seablzj">
      <p>
          搜索到 “{{ inplist.title }}” 共 <span>{{ inplist.total }}</span
          >条结果
      </p>
    </div>
    <div class="searchbox">
      <div class="searl">
        <listleft class="listleft"></listleft>
      </div>
      <div class="seabl">

        <div class="seabluls">
          <ul>
            <li class="seazxlis" v-for="item in serlist" v-bind:key="item.id" @click="handlelitxq(item.id)">
              <!-- <div class="sealisl">
                  <span>本地资讯</span>
                </div> -->
              <div class="sealisr">
                <div class="sealsrtit">
                  <span class="sealtdm"><img src="../assets/images/tfzd.png" style="width: 12px;float:left;margin:5px 5px 0 0 ;" alt="" v-if="item.istop" />{{ item.title }}</span>
                  <span class="sealtsj">{{ time(item.createTime, "YYYY-MM-DD") }}</span>
                </div>

                <div class="sealtct two-line" v-if="item.summary">{{ item.summary | ellipsis }}</div>
                <div class="sealtct two-line" v-else>{{ item.content | ellipsis }}</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="seablym">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="inplist.page"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :hide-on-single-page="value"
            :total="inplist.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <footbox></footbox>
  </div>
</template>
<script>
import listleft from "@/components/listleft.vue";
import headbox from "../components/head.vue";
import footbox from "@/components/footer.vue";
import { news } from "@/api/index.js";
import { $fmtTime } from "@/utils/utils.js";
export default {
  name: "Search",
  filters: {
    ellipsis(value) {
      // 正则去除html标签
      if (value.match(/[\u4e00-\u9fa5]/g)) {
        value = value.match(/[\u4e00-\u9fa5]/g).join("");
      } else {
        return;
      }
      // 不为空将显示字数小于90个
      if (value.length > 100) {
        return value.slice(0, 100) + "...";
      }
      return value;
    },
  },
  data() {
    return {
      inplist: {
        siteId: 5,
        online: 1,
        enabled: 1,
        english: 0,
        title: this.$route.query.title,
        page: 1,
        limit: 10,
        total: 0,
      },
      serlist: [],
      value: false,
    };
  },
  //声明传递过来的子组件
  components: {
    headbox,
    footbox,
    listleft,
  },
  created() {
    this.serbtn();
  },
  methods: {
    // 获取搜索数据
    serbtn() {
      news(this.inplist).then((res) => {
        this.serlist = res.data.data.records;
        this.inplist.total = res.data.data.total;
        if (res.data.data.total === 0) {
          this.value = true;
        } else {
          return;
        }
      });
    },
    handlelitxq(id) {
      this.$router.push({ path: "show", query: { id: id } });
    },
    handleSizeChange(val) {
      this.inplist.limit = val;
      this.serbtn();
    },
    handleCurrentChange(val) {
      this.inplist.page = val;
      this.serbtn();
    },
  },
  computed: {
    time() {
      return $fmtTime;
    },
  },
};
</script>
<style lang="less" scoped>
.listleft {
  @media screen and (max-width: 900px) {
    display: none;
  }
}
.searchbox {
  max-width: 1200px;
  min-height: 900px;
  margin: 0 auto;
  background: #fff;
  display: flex;
  text-align: left;
  @media screen and (max-width: 900px) {
    display: block;
  }
}
.seabl {
  flex: 7.5;
  color: #525252;
  font-family: PingFang SC-Light;
  margin-right: 48px;
}
.searl {
  // flex: 2.5;
  width:25%;
  padding: 20px 20px 0 0;
   @media screen and (max-width:800px) {
    display: none;
  }
}
.seabluls{
  padding-top:20px;
}
.seablzj {
  color: #525252;
  text-align: left;
  max-width:1200px;
  margin:auto;
  background: #fff;
  @media screen and (max-width:900px) {
    display: none;
  }
}
.seablzj> p{
  border-bottom: 2px dashed #c1c1c1;
  padding: 15px 0;
  margin:0 32px;

}
.seazxlis {
  display: flex;
  border-bottom: 2px dashed #c1c1c1;
  margin-right: 15px;
  margin: 15px 0;
}
.sealisl {
  flex: 2;
}
.sealisr {
  flex: 17;
}
.sealisl > span {
  color: #ff9900;
  background: #fff3de;
  padding: 2px 5px 2px 5px;
}
.sealtdm {
  font-size: 16px;
  color: #1a1a1a;
  font-weight: 600;
  max-width: 710px;
  width: 80%;
  float: left;
  cursor: pointer;
}
.sealtdm:hover{
  color:#ff9900
}
.sealtsj {
  float: right;
  color: #8d8d8d;
  font-size: 13px;
  width: 152px;
  text-align: right;
}
.sealsrtit {
  color: #5a5a5a;
  overflow: hidden;
}
.sealtct {
  font-size: 15px;
  color: #7a7a7a;
  margin: 10px 0 15px 0;
  width: 100%;
}
.seablym {
  margin: 50px 70px 50px 70px;
  color: #525252;
}
.seablym > span {
  border: 1px solid #c4c4c4;
  padding: 5px 13px;
  font-size: 13px;
}
.clkcor {
  color: #fff;
  background: #ff9900;
  border: 0;
}
.fistsp {
  color: #c4c4c4;
  margin-left: 13px;
}
.clkinp {
  margin: 0 5px;
}
.clkinp > input {
  width: 22px;
  height: 20px;
  border: 0;
  outline: none;
}
.serbtn {
  background: #ff9900;
  color: #fff;
  font-size: 24px;
  padding: 6px 0 6px 15px;

  display: block;
  font-family: PingFang SC-Regular;
}
@media screen and(max-width:1170px) {
  .seablym {
    margin: 50px 0 50px 0;
  }
}
@media screen and(max-width:1050px) {
  .seazxlis {
    display: block;
  }
}
@media screen and(max-width:850px) {
  .searchbox {
    display: block;
  }
  .serbtn {
    width: 125px;
    padding: 6px 0 6px 36px;
  }
  .searl {
    border-bottom: 1px solid #e1e1e1;
    margin-right: 0px;
  }
  .seabl {
    margin-right: 0px;
  }
}
</style>
